module.exports = __webpack_public_path__ + "static/media/document.6684005d.png";